import { render, staticRenderFns } from "./DoughnutWeekNumbers.vue?vue&type=template&id=5a1600da&scoped=true&"
import script from "./DoughnutWeekNumbers.vue?vue&type=script&lang=js&"
export * from "./DoughnutWeekNumbers.vue?vue&type=script&lang=js&"
import style0 from "./DoughnutWeekNumbers.vue?vue&type=style&index=0&id=5a1600da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1600da",
  null
  
)

export default component.exports